import React from "react";

export const BankFeedsIcon: React.FC = () => {
  return (
    <svg
      data-testid="bank-feeds-icon"
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_dd_1530_318)">
        <g clipPath="url(#clip0_1530_318)">
          <rect x="3" y="2" width="48" height="48.0001" rx="8" fill="#64F2A1" />
          <rect
            x="35.123"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 35.123 2)"
            fill="#134E48"
          />
          <rect
            x="38.6738"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 38.6738 2)"
            fill="#134E48"
          />
          <rect
            x="31.5723"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 31.5723 2)"
            fill="#134E48"
          />
          <rect
            x="24.4727"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 24.4727 2)"
            fill="#134E48"
          />
          <rect
            x="20.9238"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 20.9238 2)"
            fill="#134E48"
          />
          <rect
            x="17.373"
            y="2"
            width="47.9986"
            height="2.0499"
            transform="rotate(90 17.373 2)"
            fill="#134E48"
          />
          <rect
            x="51"
            y="34.127"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 34.127)"
            fill="#134E48"
          />
          <rect
            x="51"
            y="37.6758"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 37.6758)"
            fill="#134E48"
          />
          <rect
            x="51"
            y="30.5762"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 30.5762)"
            fill="#134E48"
          />
          <rect
            x="51"
            y="23.4766"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 23.4766)"
            fill="#134E48"
          />
          <rect
            x="51"
            y="19.9258"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 19.9258)"
            fill="#134E48"
          />
          <rect
            x="51"
            y="16.375"
            width="47.9985"
            height="2.0499"
            transform="rotate(-180 51 16.375)"
            fill="#134E48"
          />
          <g filter="url(#filter1_di_1530_318)">
            <rect
              x="7"
              y="6"
              width="40"
              height="40.0001"
              rx="6"
              fill="#1A0044"
            />
            <rect
              x="7.24859"
              y="6.24859"
              width="39.5028"
              height="39.5029"
              rx="5.75141"
              stroke="black"
              strokeOpacity="0.2"
              strokeWidth="0.49718"
            />
          </g>
          <g filter="url(#filter2_i_1530_318)">
            <path
              d="M18.8333 22.5008V31.8342M24.0833 22.5008V31.8342M29.9167 22.5008V31.8342M35.1667 22.5008V31.8342M16.5 33.7008L16.5 34.6342C16.5 35.2876 16.5 35.6143 16.6272 35.8638C16.739 36.0834 16.9175 36.2618 17.137 36.3737C17.3866 36.5008 17.7133 36.5008 18.3667 36.5008H35.6333C36.2867 36.5008 36.6134 36.5009 36.863 36.3737C37.0825 36.2618 37.261 36.0834 37.3729 35.8638C37.5 35.6143 37.5 35.2876 37.5 34.6342V33.7008C37.5 33.0475 37.5 32.7208 37.3729 32.4712C37.261 32.2517 37.0825 32.0732 36.863 31.9613C36.6134 31.8342 36.2867 31.8342 35.6333 31.8342H18.3667C17.7133 31.8342 17.3866 31.8342 17.137 31.9613C16.9175 32.0732 16.739 32.2517 16.6272 32.4712C16.5 32.7208 16.5 33.0475 16.5 33.7008ZM26.5951 15.5908L17.9617 17.5093C17.4402 17.6252 17.1794 17.6832 16.9847 17.8234C16.813 17.9471 16.6782 18.1152 16.5947 18.3097C16.5 18.5301 16.5 18.7973 16.5 19.3316L16.5 20.6342C16.5 21.2876 16.5 21.6143 16.6272 21.8638C16.739 22.0834 16.9175 22.2618 17.137 22.3737C17.3866 22.5008 17.7133 22.5008 18.3667 22.5008H35.6333C36.2867 22.5008 36.6134 22.5008 36.863 22.3737C37.0825 22.2618 37.261 22.0834 37.3729 21.8638C37.5 21.6143 37.5 21.2876 37.5 20.6342V19.3316C37.5 18.7973 37.5 18.5301 37.4053 18.3097C37.3218 18.1152 37.187 17.9471 37.0153 17.8234C36.8206 17.6832 36.5599 17.6252 36.0383 17.5093L27.4049 15.5908C27.2538 15.5572 27.1783 15.5405 27.1019 15.5338C27.0341 15.5278 26.9659 15.5278 26.8981 15.5338C26.8217 15.5405 26.7462 15.5572 26.5951 15.5908Z"
              stroke="white"
              strokeWidth="1.7846"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </g>
        </g>
        <rect
          x="3.21818"
          y="2.21818"
          width="47.5636"
          height="47.5637"
          rx="7.78182"
          stroke="black"
          strokeOpacity="0.2"
          strokeWidth="0.436364"
        />
      </g>
      <defs>
        <filter
          id="filter0_dd_1530_318"
          x="0.745718"
          y="0.497145"
          width="52.5086"
          height="52.5086"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feMorphology
            radius="0.751427"
            operator="erode"
            in="SourceAlpha"
            result="effect1_dropShadow_1530_318"
          />
          <feOffset dy="0.751427" />
          <feGaussianBlur stdDeviation="0.751427" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1530_318"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.751427" />
          <feGaussianBlur stdDeviation="1.12714" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_1530_318"
            result="effect2_dropShadow_1530_318"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect2_dropShadow_1530_318"
            result="shape"
          />
        </filter>
        <filter
          id="filter1_di_1530_318"
          x="3"
          y="3"
          width="48"
          height="48"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="2" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1530_318"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_1530_318"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.99436" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_1530_318"
          />
        </filter>
        <filter
          id="filter2_i_1530_318"
          x="13"
          y="12"
          width="28"
          height="28"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset />
          <feGaussianBlur stdDeviation="0.0605682" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_1530_318"
          />
        </filter>
        <clipPath id="clip0_1530_318">
          <rect x="3" y="2" width="48" height="48.0001" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
